import React from 'react';
import {
  VictoryArea,
  VictoryAxis,
  VictoryChart,
  VictoryClipContainer,
  VictoryLine,
  VictoryScatter,
} from 'victory';
import { ChartTouchArea } from './styles';
import { colors } from '../../../config/theme';

export const LineChart = ({
  firstDataSet = [],
  maxCheckins = 10,
  sectionKey = 'week',
}) => {
  const firstArrayValue = [...firstDataSet.map((item) => item.y)];

  const upperAxisBound = Math.max(...firstArrayValue, maxCheckins);
  const lowerAxisBound = 0; // Setting the lower bound for gradient area

  return (
    <ChartTouchArea>
      <VictoryChart
        key={sectionKey}
        animate={{
          duration: 1500,
          onLoad: { duration: 500 },
        }}
        height={190}
        domainPadding={20}
        // Reserve space for dependent-axis labels. The previous 24px gutter
        // clipped multi-digit active-day totals on profile timelines.
        padding={{ top: 5, bottom: 50, left: 56, right: 12 }}
      >
        <defs>
          <linearGradient id="myGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            {/* Set through style, not the stop-color attribute: custom
                properties only resolve in CSS, not in SVG attribute values. */}
            <stop
              offset="0%"
              style={{ stopColor: colors.primary }}
              stopOpacity={0.7}
            />
            <stop offset="100%" stopColor="transparent" stopOpacity={0.1} />
          </linearGradient>
        </defs>

        <VictoryArea
          data={firstDataSet.map((data) => {
            return { x: data.x, y: Math.max(data.y, lowerAxisBound) };
          })}
          interpolation="catmullRom"
          style={{
            data: { fill: 'url(#myGradient)' },
          }}
          groupComponent={
            <VictoryClipContainer clipPadding={{ top: 0, bottom: 0 }} />
          }
        />

        <VictoryLine
          animate={{
            duration: 1500,
            onLoad: { duration: 500 },
          }}
          data={firstDataSet}
          interpolation="catmullRom"
          style={{
            data: { stroke: colors.primary, strokeWidth: 2 },
          }}
        />

        <VictoryScatter
          data={firstDataSet}
          size={3}
          style={{ data: { fill: colors.primary } }}
        />

        <VictoryAxis
          dependentAxis
          domain={[0, upperAxisBound]}
          tickCount={4}
          tickFormat={(x) => `${Math.round(x)}`}
          style={{
            axis: { stroke: colors.textPrimary },
            tickLabels: { fill: colors.textPrimary },
            grid: { stroke: 'gray', strokeDasharray: '2, 2' },
          }}
        />

        <VictoryAxis
          style={{
            axis: { stroke: colors.textPrimary },
            tickLabels: { fill: colors.textPrimary },
          }}
        />
      </VictoryChart>
    </ChartTouchArea>
  );
};
